export const expenseSchema = {
  amount: (amount) => amount,

  description: (description) => description || "",
  serviceDate: (serviceDate) => serviceDate,
  patientId: (patientId) => patientId,
  providerId: (providerId) => providerId,
  taxYear: (taxYear) => Number(taxYear),
  documents: (documents) => documents,
  amountFromHsaBalance: (amountFromHsaBalance) => amountFromHsaBalance,
  targetAccount: (targetAccount) => targetAccount,
  amountFromSaveAsYouGo: (amountFromSaveAsYouGo) => amountFromSaveAsYouGo,
  amountFromHraBalance: (amountFromHraBalance) => amountFromHraBalance,
};

export default expenseSchema;
